// Piezas chicas de las celdas de Clientes.

/** Un dato sin fuente: guion, con el motivo al alcance del cursor. */
export function Missing({ reason }: { reason: string }) {
    return (
        <span title={reason} className="cursor-help text-muted-foreground">
            —
        </span>
    );
}

/** Encabezado que parte en dos renglones en vez de cortarse con puntos suspensivos. */
export function WrapLabel({ children }: { children: string }) {
    return <span className="block whitespace-normal leading-tight">{children}</span>;
}
